import { MarkdownContent } from 'elements/visual/MarkdownContent';
import { EFonts } from 'libs/styles/styling';
import styled from 'styled-components/macro';

interface Props {
    className?: string;
    title?: string;
    text?: string;
}

export const ContentText = (props: Props): JSX.Element => {
    return (
        <S_ContentText className={props.className}>
            {props.title && <S_Title>{props.title}</S_Title>}
            {props.text && props.title && <S_Split />}
            {props.text && <S_Text text={props.text} />}
        </S_ContentText>
    );
};

const S_ContentText = styled.div`
    padding: 0 20px;
`;

const S_Title = styled.div`
    font-size: 18px;
    line-height: 24px;
    color: #2a2a2d;
    font-family: ${EFonts.InterSemiBold};
`;

const S_Text = styled(MarkdownContent)`
    color: #2a2a2d;
    font-family: ${EFonts.InterRegular};
    font-size: 15px;
    line-height: 24px;
    p {
        font-family: ${EFonts.InterRegular};
    }
`;

const S_Split = styled.div`
    height: 1px;
    margin: 5px 0;
`;
